// project imports
// import AuthenticatedRoute from './../AuthenticatedRoute';
import Product from '../views/Product';
import BankDetails from '../views/BankDetails';
import CardDetails from '../views/CardDetails';
import ThankYou from '../views/Thankyou';
import Login from '../views/Login';
import UnSuccessful from '../views/UnSuccessful';
import Address from '../views/Address';
import Payment from '../views/payment';
import PayDeposit from '../views/PayDeposit';




// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = [
    {
        path: '/',
        element: <Login />
    },
    {
        path: '/product',
        element: <Product />
    },
    {
        path: 'address',
        element: <Address />
    },
    {
        path: 'payment',
        element: <Payment />
    },
    {
        path: 'bankdetails',
        element: <BankDetails />
    },
    {
        path: 'carddetails',
        element: <CardDetails />
    },
    {
        path: 'thankyou/:id',
        element: <ThankYou />
    },
    {
        path: 'unsuccessful/:id',
        element: <UnSuccessful />
    },
    {
        path: 'pay-deposit',
        element: <PayDeposit />
    }
];

export default MainRoutes;
